const isEmptyValue = (value) =>
  [undefined, 'undefined', null, 'null', ''].includes(value);

export const idsEqual = (a, b) => {
  if (isEmptyValue(a) || isEmptyValue(b)) {
    return false;
  }
  return a === b || String(a) === String(b);
};

export const accountIdsInLineage = (accounts, parentAccountId) => {
  if (isEmptyValue(parentAccountId)) {
    return [];
  }
  const list = accounts || [];
  const parent = list.find((account) =>
    idsEqual(account.id || account.value, parentAccountId)
  );
  if (!parent) {
    return [parentAccountId];
  }
  const parentLineage = String(parent.account_lineage || '');
  if (!parentLineage) {
    return [parent.id || parent.value || parentAccountId];
  }
  return list
    .filter((account) => {
      const lineage = String(account.account_lineage || '');
      if (!lineage) {
        return idsEqual(account.id || account.value, parentAccountId);
      }
      return lineage === parentLineage || lineage.startsWith(`${parentLineage}.`);
    })
    .map((account) => account.id || account.value);
};

export const locationsInAccountLineage = (locations, accounts, parentAccountId) => {
  const allowed = accountIdsInLineage(accounts, parentAccountId);
  return (locations || []).filter((location) =>
    allowed.some((id) =>
      idsEqual(location.account_id || location.parent_account_id, id)
    )
  );
};

export const firstLocationInLineage = (locations, accounts, parentAccountId) => {
  const scoped = locationsInAccountLineage(locations, accounts, parentAccountId);
  return (scoped[0] && scoped[0].id) || '';
};

export const locationParentAccountName = (location, accounts) => {
  if (!location) return '';
  if (location.account_name) {
    return location.account_name;
  }
  const accountId = location.account_id || location.parent_account_id;
  const match = (accounts || []).find((item) =>
    idsEqual(item.id || item.value, accountId)
  );
  return (match && (match.name || match.brandName)) || '';
};

export const locationParentLogoUrl = (location, accounts) => {
  if (!location) return '';
  const accountId = location.account_id || location.parent_account_id;
  const match = (accounts || []).find((item) =>
    idsEqual(item.id || item.value, accountId)
  );
  const brandLogo = (match && match.logoUrl) || '';
  const locationLogo = location.logo_url || '';
  const usable = (url) =>
    !!url && !/ilocal-logo-primary/i.test(String(url));
  if (usable(locationLogo)) {
    return locationLogo;
  }
  if (usable(brandLogo)) {
    return brandLogo;
  }
  return '';
};




// WEBPACK FOOTER //
// ./src/components/message-control-center/lineage.js